/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'automation-menu.empty-state.image.alt': 'Ikona prázdného seznamu automatizace',
  'automation-menu.empty-state.learn-more.link': 'Další informace o ručním spouštěči',
  'automation-menu.modal.empty.automations.admin.description':
    'Pomocí ručního spouštěče můžete vytvořit nabídku výběrů, které může kdokoli nebo vámi určené osoby jedním kliknutím použít jako automatizaci.',
  'automation-menu.modal.empty.automations.user.description':
    'Správci zatím nenakonfigurovali žádné ručně spouštěné automatizace.',
  'automation-menu.modal.error.description': 'Načtení může chvíli trvat. Zkuste obnovit stránku.',
  'automation-menu.modal.error.image.alt': 'Ikona chyby',
  'automation-menu.modal.footer.automate-button': 'Automatizovat',
  'automation-menu.modal.footer.cancel-button': 'Zrušit',
  'automation-menu.modal.footer.get-started-button': 'Vytvořit automatizaci',
  'automation-menu.modal.footer.ok-button': 'OK',
  'automation-menu.modal.header.icon.label': 'Ikona v záhlaví modálního okna automatizace',
  'automation-menu.success-state.message': 'Vaše automatizace probíhá',
  'fabric.linking.access_exists_description': 'Požádejte o přístup k zobrazení tohoto obsahu z webu {hostname}.',
  'fabric.linking.actions': 'Akce',
  'fabric.linking.add_account': 'Přidat účet',
  'fabric.linking.ai_summarize': 'Shrnout',
  'fabric.linking.ai_summarized': 'Shrnuto pomocí Atlassian Intelligence',
  'fabric.linking.ai_summarized_abbreviation': 'Shrnuto pomocí AI',
  'fabric.linking.ai_summarized_info': 'Kvalita informací se může různit. <a>Další informace</a>',
  'fabric.linking.ai_summarized_info_short': 'Kvalita obsahu se může různit.',
  'fabric.linking.ai_summarizing': 'Atlassian Intelligence pracuje…',
  'fabric.linking.ai_summary_action': 'Shrnout pomocí AI',
  'fabric.linking.ai_summary_action_description': 'Shrňte obsah tohoto odkazu pomocí Atlassian Intelligence.',
  'fabric.linking.ai_summary_error_acceptable_use_violation':
    'Výsledky tohoto souhrnu nemůžeme zobrazit, protože jsou v rozporu se <a>Zásadami přijatelného používání společnosti Atlassian</a>.',
  'fabric.linking.ai_summary_error_exceeding_context_length_error':
    'Atlassian Intelligence pro vás momentálně nemůže vygenerovat souhrn, protože obsahu ke shrnutí je příliš mnoho.',
  'fabric.linking.ai_summary_error_generic':
    'Atlassian Intelligence (AI) neodpovídá. Zkuste to znovu později nebo <a>zkontrolujte stav AI</a>.',
  'fabric.linking.ai_summary_error_hipaa_content_detected':
    'Atlassian Intelligence nedokázala zpracovat vaši žádost, protože váš obsah obsahuje odkazy na obsah omezený HIPAA.',
  'fabric.linking.assigned_to': 'Přiřazeno k: {context}',
  'fabric.linking.automation-action.confluence.page.modal.description':
    'Použijte automatizaci u položky <b>{name}</b>.{br}Dostupné výběry jsou určeny správci Confluence a prostorů.',
  'fabric.linking.automation-action.confluence.page.modal.title': 'Automatizace stránek',
  'fabric.linking.automation-action.icon.label': 'Ikona automatizace',
  'fabric.linking.automation-action.title': 'Zobrazit pravidla automatizace',
  'fabric.linking.automation-action.tooltip': 'Vyberte pravidlo automatizace, které chcete spustit.',
  'fabric.linking.beta': 'Beta',
  'fabric.linking.cancel': 'Zrušit',
  'fabric.linking.cannot_connect': 'Nelze se připojit, zkuste to znovu.',
  'fabric.linking.cannot_find_link': 'Nepodařilo se najít odkaz.',
  'fabric.linking.check_this_link': 'Ověřte tento odkaz',
  'fabric.linking.click_to_join': 'Připojte se k {context}',
  'fabric.linking.click_to_join_description':
    'Byli jste schváleni, takže se můžete okamžitě připojit k řešení {context}.',
  'fabric.linking.close': 'Zavřít',
  'fabric.linking.connect_account_description': 'Otevřeme novou stránku, abychom vám pomohli připojit váš {name} účet.',
  'fabric.linking.connect_link_account': 'Pokud chcete zobrazit náhled, připojte svůj účet',
  'fabric.linking.connect_link_account_card_view': 'Připojit',
  'fabric.linking.connect_link_account_card_view_description':
    'Pokud chcete zobrazit náhled tohoto odkazu, připojte svůj účet {context}.',
  'fabric.linking.connect_link_account_card_view_name': 'Připojte svůj účet {context}',
  'fabric.linking.connect_to': 'Připojit k {name}',
  'fabric.linking.connect_unauthorised_account_action': 'Připojit k: {context}',
  'fabric.linking.connect_unauthorised_account_description':
    'Připojte svůj účet {context} a spolupracujte pomocí všech produktů Atlassian.',
  'fabric.linking.connect_unauthorised_account_description_no_provider':
    'Připojte svůj účet a spolupracujte pomocí všech produktů Atlassian.',
  'fabric.linking.continue': 'Pokračovat',
  'fabric.linking.copied_summary_action_description': 'Souhrn byl zkopírován do schránky.',
  'fabric.linking.copied_url_to_clipboard': 'Zkopírováno',
  'fabric.linking.copy_summary_action': 'Zkopírovat souhrn',
  'fabric.linking.copy_summary_action_description': 'Zkopírovat souhrn',
  'fabric.linking.copy_url_to_clipboard': 'Kopírovat odkaz',
  'fabric.linking.couldnt_load_link': 'Tento odkaz se z neznámého důvodu nepodařilo načíst.',
  'fabric.linking.create_on_absolute': 'Vytvořeno: {context}',
  'fabric.linking.create_on_relative': 'Vytvořeno: {context}',
  'fabric.linking.created_by': 'Vytvořil(a) {context}',
  'fabric.linking.delete': 'Odstranit',
  'fabric.linking.direct_access': 'Připojit se',
  'fabric.linking.direct_access_description':
    'Váš tým spolupracuje v {product} a vy můžete tento produkt hned začít používat také!',
  'fabric.linking.direct_access_title': 'Chcete-li si zobrazit tento obsah, připojte se k produktu {product}',
  'fabric.linking.download': 'Stáhnout',
  'fabric.linking.download_description': 'Stáhněte si tento soubor do místního úložiště.',
  'fabric.linking.download_file': 'Stáhnout soubor',
  'fabric.linking.edit': 'Upravit',
  'fabric.linking.follow': 'Sledovat',
  'fabric.linking.follow_goal': 'Sledovat cíl',
  'fabric.linking.follow_goal_description': 'Chcete-li dostávat oznámení o aktualizacích, začněte sledovat tento cíl.',
  'fabric.linking.follow_goal_error':
    'Při pokusu o zahájení sledování cíle došlo k chybě. Zkontrolujte připojení nebo obnovte stránku a zkuste to znovu.',
  'fabric.linking.follow_project': 'Sledovat projekt',
  'fabric.linking.follow_project-galaxia': 'Sledovat prostor',
  'fabric.linking.follow_project_description': 'Chcete-li dostávat oznámení o tomto projektu, začněte ho sledovat.',
  'fabric.linking.follow_project_description-galaxia':
    'Chcete-li dostávat oznámení o tomto prostoru, začněte ho sledovat.',
  'fabric.linking.follow_project_error':
    'Při pokusu o zahájení sledování projektu došlo k chybě. Zkontrolujte připojení nebo obnovte stránku a zkuste to znovu.',
  'fabric.linking.follow_project_error-galaxia':
    'Při pokusu o zahájení sledování prostoru došlo k chybě. Zkontrolujte připojení nebo obnovte stránku a zkuste to znovu.',
  'fabric.linking.forbidden_access': 'Přístup byl odepřen',
  'fabric.linking.forbidden_description': 'Pokud chcete požádat o přístup k webu {hostname}, kontaktujte správce.',
  'fabric.linking.forbidden_title': 'K tomuto obsahu nemáte přístup',
  'fabric.linking.generic_error_message': 'Došlo k chybě',
  'fabric.linking.go_back': 'Přejít zpět',
  'fabric.linking.invalid_permissions': 'Omezený obsah',
  'fabric.linking.invalid_permissions_description':
    'Pokud si chcete zobrazit tento náhled, požádejte o přístup nebo vyzkoušejte jiný účet.',
  'fabric.linking.join_to_view': 'Chcete-li si zobrazit tento požadavek, připojte se ke službě {context}.',
  'fabric.linking.join_to_view-issue-term-refresh':
    'Chcete-li si zobrazit tento požadavek, připojte se ke službě {context}.',
  'fabric.linking.learn_more_about_connecting_account': 'Další informace o propojení účtu s produkty Atlassian.',
  'fabric.linking.learn_more_about_smart_links': 'Další informace o chytrých odkazech',
  'fabric.linking.link_safety_warning_message':
    'Odkaz {unsafeLinkText} vás přesměruje na jiný web (<a>actual link here</a>)',
  'fabric.linking.loading': 'Načítání…',
  'fabric.linking.modified_on_absolute': 'Aktualizováno: {context}',
  'fabric.linking.modified_on_relative': 'Aktualizováno: {context}',
  'fabric.linking.more_actions': 'Další akce',
  'fabric.linking.no_access_title': 'Chcete-li si zobrazit tento obsah, připojte se k produktu {product}',
  'fabric.linking.not_found_description': 'Stránka neexistuje nebo se po přidání tohoto odkazu mohla změnit.',
  'fabric.linking.not_found_title': 'Tuto stránku {product} vám nemůžeme zobrazit',
  'fabric.linking.open_issue_in_jira': 'Otevřít požadavek v Jira',
  'fabric.linking.open_issue_in_jira-issue-term-refresh': 'Otevřít požadavek v Jira',
  'fabric.linking.open_link_in_a_new_tab': 'Otevřít odkaz na nové kartě',
  'fabric.linking.owned_by': 'Vlastník: {context}',
  'fabric.linking.owned_by_override': 'Od autora {context}',
  'fabric.linking.pending_request': 'Vaše žádost o přístup čeká na vyřízení.',
  'fabric.linking.preview_close': 'Zavřít náhled',
  'fabric.linking.preview_description': 'Otevřít náhled tohoto odkazu na celé obrazovce',
  'fabric.linking.preview_improved': 'Otevřít náhled',
  'fabric.linking.preview_max_size': 'Zobrazit na celé obrazovce',
  'fabric.linking.preview_min_size': 'Zavřít zobrazení na celé obrazovce',
  'fabric.linking.preview_modal': 'Otevřít modální okno náhledu',
  'fabric.linking.preview_panel': 'Otevřít panel náhledu',
  'fabric.linking.priority_blocker': 'Blokující',
  'fabric.linking.priority_critical': 'Kritická',
  'fabric.linking.priority_high': 'Vysoká',
  'fabric.linking.priority_highest': 'Nejvyšší',
  'fabric.linking.priority_low': 'Nízká',
  'fabric.linking.priority_lowest': 'Nejnižší',
  'fabric.linking.priority_major': 'Vysoká',
  'fabric.linking.priority_medium': 'Střední',
  'fabric.linking.priority_minor': 'Nízká',
  'fabric.linking.priority_trivial': 'Triviální',
  'fabric.linking.priority_undefined': 'Nedefinováno',
  'fabric.linking.read_time': '{context} min. čtení',
  'fabric.linking.related': 'Souvisící',
  'fabric.linking.related_links_found_in': 'Nalezeno v:',
  'fabric.linking.related_links_includes_links_to': 'Zahrnuje odkazy na:',
  'fabric.linking.related_links_modal_error_description':
    'Zkontrolujte připojení nebo obnovte stránku a zkuste to znovu.',
  'fabric.linking.related_links_modal_error_title': 'Při načítání souvisejících odkazů se vyskytly problémy',
  'fabric.linking.related_links_modal_title': 'Související odkazy',
  'fabric.linking.related_links_modal_unavailable_description':
    'Neustále kontrolujeme a přidáváme související odkazy na aktualizované stránky nebo jiné typy obsahu.',
  'fabric.linking.related_links_modal_unavailable_title': 'Nepodařilo se najít žádné související odkazy',
  'fabric.linking.related_links_not_found': 'Nebyly nalezeny žádné odkazy, které bychom tu mohli zobrazit.',
  'fabric.linking.related_links_view_related_links': 'Zobrazit související odkazy',
  'fabric.linking.related_links_view_related_urls': 'Zobrazit nedávné odkazy',
  'fabric.linking.request_access': 'Požádat o přístup',
  'fabric.linking.request_access_description': 'Váš tým spolupracuje v {product}. Pošlete správci žádost o přístup.',
  'fabric.linking.request_access_pending': 'Čeká na schválení',
  'fabric.linking.request_access_pending_description': 'Vaše žádost o přístup z {hostname} čeká na schválení správcem.',
  'fabric.linking.request_access_pending_title': 'Přístup k {product} čeká na vyřízení',
  'fabric.linking.request_access_to_view':
    'Chcete-li si zobrazit tento požadavek, požádejte o přístup ke službě {context}.',
  'fabric.linking.request_access_to_view-issue-term-refresh':
    'Chcete-li si zobrazit tento požadavek, požádejte o přístup ke službě {context}.',
  'fabric.linking.request_denied': 'Vaše žádost o přístup byla odmítnuta.',
  'fabric.linking.request_denied_description':
    'Správce neschválil vaši žádost o zobrazení stránek {product} z {hostname}.',
  'fabric.linking.restricted_link': 'Omezený odkaz, zkuste jiný účet.',
  'fabric.linking.retry': 'Zkusit znovu',
  'fabric.linking.save': 'Uložit',
  'fabric.linking.sent_on_absolute': 'Odesláno {context}',
  'fabric.linking.sent_on_relative': 'Odesláno {context}',
  'fabric.linking.srclink': 'Zobrazit v',
  'fabric.linking.srclinkunknown': 'Zobrazit originál',
  'fabric.linking.status_change_load_error': 'Načtení stavů a přechodů se nezdařilo',
  'fabric.linking.status_change_permission_error': 'K provedení přechodu tohoto požadavku nemáte oprávnění.',
  'fabric.linking.status_change_permission_error-issue-term-refresh':
    'K provedení přechodu tohoto požadavku nemáte oprávnění.',
  'fabric.linking.status_change_update_error': 'Aktualizace stavu se nezdařila',
  'fabric.linking.team_members_count': 'Členů: {context}',
  'fabric.linking.try_again': 'Zkusit znovu',
  'fabric.linking.try_another_account': 'Zkuste jiný účet',
  'fabric.linking.unassigned': 'Nepřiřazeno',
  'fabric.linking.unauthorised_account_description':
    'Pokoušíte se zobrazit náhled odkazu na soukromou stránku ze zdroje {context}. Doporučujeme zkontrolovat adresu URL nebo kontaktovat vlastníka stránky.',
  'fabric.linking.unauthorised_account_description_no_provider':
    'Pokoušíte se zobrazit náhled odkazu na soukromou stránku. Doporučujeme zkontrolovat adresu URL nebo kontaktovat vlastníka stránky.',
  'fabric.linking.unauthorised_account_name': 'Soukromé stránky ze zdroje {context} nejde zobrazit.',
  'fabric.linking.unauthorised_account_name_no_provider': 'Soukromé stránky nejde zobrazit.',
  'fabric.linking.unfollow': 'Přestat sledovat',
  'fabric.linking.unfollow_goal': 'Přestat sledovat cíl',
  'fabric.linking.unfollow_goal_description': 'Pokud už nechcete dostávat oznámení o tomto cíli, zrušte sledování.',
  'fabric.linking.unfollow_goal_error':
    'Při pokusu o zrušení sledování cíle došlo k chybě. Zkontrolujte připojení nebo obnovte stránku a zkuste to znovu.',
  'fabric.linking.unfollow_project': 'Přestat sledovat projekt',
  'fabric.linking.unfollow_project-galaxia': 'Přestat sledovat prostor',
  'fabric.linking.unfollow_project_description': 'Pokud už nechcete dostávat oznámení o projektu, zrušte sledování.',
  'fabric.linking.unfollow_project_description-galaxia':
    'Pokud už nechcete dostávat oznámení o prostoru, zrušte sledování.',
  'fabric.linking.unfollow_project_error':
    'Při pokusu o zrušení sledování projektu došlo k chybě. Zkontrolujte připojení nebo obnovte stránku a zkuste to znovu.',
  'fabric.linking.unfollow_project_error-galaxia':
    'Při pokusu o zrušení sledování prostoru došlo k chybě. Zkontrolujte připojení nebo obnovte stránku a zkuste to znovu.',
  'fabric.linking.unlink_account': 'Odpojit účet',
  'fabric.linking.updated_by': 'Upravil(a) {context}',
  'fabric.linking.user_attributes': '{context}',
  'fabric.linking.view': 'Zobrazit',
};
